import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { of } from 'rxjs';
import { collabDto } from 'src/app/models/collabDto';
import { entite } from 'src/app/models/entite';
import { collabService } from 'src/app/services/collab/collabService.service';
import { EntitebackService } from 'src/app/services/entite/entiteback.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { FormVendeurModifComponent } from '../../form-vendeur-modif/form-vendeur-modif.component';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-liste-vendeurs-entite',
  templateUrl: './liste-vendeurs-entite.component.html',
  imports:[TableModule,CommonModule,DialogModule,ToastModule,FormVendeurModifComponent,ButtonModule],
  styleUrls: ['./liste-vendeurs-entite.component.scss'],
  providers: [MessageService]

})
export class ListeVendeursEntiteComponent implements OnInit {

  // @Input()
  entite!: number;
  entity!: entite;
  isForModifvendeur = false;
  // handleClose() {

  //   this.collab.getcollab().subscribe(data => {
  //     this.vendeurs = data;


  //   })
  // }
  getProfil(char: string): string {

    if (char === '1') {

      return 'Admin';
    }

    if (char === '2') {

      return 'Interne';
    }
    if (char === '3' || char === '4') {

      return 'Externe';
    }
    return '';


  }
  vendeurs!: collabDto[];
  constructor(private readonly collab: collabService, private readonly entiteserv: EntitebackService,
    private readonly messageService: MessageService, public share: shareOpeSevices) { }

  ngOnInit() {


    this.share.noeudficheEntite$.subscribe({

      next: ((data: any) => {

        this.entite = data.data.id;


      }),
      error: (err) => of({ dataStatut: "", errorMessage: err.error.message })
    });


    this.collab.getCollabsBynumEntite(this.entite).subscribe(data => {



      this.vendeurs = data;


    });

  }
  activer(numCollab: number) {

    this.collab.setActif(numCollab).subscribe({

      next: (response: any) => {

        if (response !== null) {

          this.messageService.add({ severity: 'success', detail: 'Activé avec Success !' });

          this.collab.getCollabsBynumEntite(this.entite).subscribe(data => {

            this.vendeurs = data;

          })

        }
        else {

          this.messageService.add({ severity: 'warn', detail: 'Erreur' });

        }
      }
    }
    )
  }

  showEntiteForm(vendeur: collabDto) {

    // this.share.isForModifvendeur = true;
    this.isForModifvendeur = true;

    this.share.sendVendeurfromList(vendeur);

  }
  /*
  getLibelleEntite(numEntite: number): string {
    this.entiteserv.getEntitebyId(numEntite).subscribe(data => {
      this.entity = data;

    })

    return this.entity.libelle;
  }
*/
}
